// extracted by mini-css-extract-plugin
export default {"sponsor":"Sponsor_sponsor__ehH1U","Router":"Sponsor_Router__9szTu","Polygon":"Sponsor_Polygon__lU5W1","Replit":"Sponsor_Replit__ix1KY"};